import React from 'react'
import MatchAllNotes from './MatchAllNotes'

const MatchNotesContainer = () => {
  return <MatchAllNotes />
}

export default MatchNotesContainer
